/* unplugin-vue-components disabled */import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { useThemeStore } from '@/stores/theme';
export default {
  __name: 'LightDarkToggle',
  setup(__props) {
    const themeStore = useThemeStore();
    const {
      setTheme
    } = themeStore;
    const {
      theme
    } = storeToRefs(themeStore);
    const themeToggle = ref(null);
    function handleThemeChange() {
      if (!themeToggle.value.checked) {
        setTheme('dark');
      } else {
        setTheme('light');
      }
    }
    onMounted(() => {
      themeToggle.value.checked = theme.value === 'light';
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("input", {
        ref_key: "themeToggle",
        ref: themeToggle,
        type: "checkbox",
        class: "toggle toggle-sm w-[35px] themeToggle",
        onClick: handleThemeChange
      }, null, 512);
    };
  }
};